import { nonNullish } from "../nullish/nullish"

/** Type guard that checks if a key exists in an object. */
export const isKeyOf = <T extends object>(
  key: PropertyKey,
  obj: T
): key is keyof T => key in obj

/** Type guard that checks if a value is a map of strings or string arrays. */
export const isStringOrStringArrayMap = (
  value: unknown
): value is { [key: string]: string | string[] } => {
  if (!nonNullish(value)) return false // {} passes
  if (typeof value !== "object") return false

  return Object.values(value).every(
    (v) =>
      typeof v === "string" ||
      (Array.isArray(v) && v.every((x) => typeof x === "string"))
  )
}
